import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import { planFragment } from "@zapier/upsells/esm/fragments";
export const nextPlanQuery = gql `
  query upsells_nextPlanQuery(
    $accountId: Int!
    $interval: BillingInterval
    $type: String
  ) {
    nextPlan: nextPlanV2(
      accountId: $accountId
      interval: $interval
      type: $type
    ) {
      ...upsells_planFragment
    }
  }
  ${planFragment}
`;
export const useNextPlan = ({ useQuery, accountId, interval, skip = false, type, }) => {
    const _useQuery = useQuery || defaultUseQuery;
    const { loading: isLoading, data, error, } = _useQuery(nextPlanQuery, {
        skip: skip || !accountId,
        variables: {
            accountId,
            interval,
            type,
        },
    });
    return {
        error: error === null || error === void 0 ? void 0 : error.message,
        isLoading,
        nextPlan: data === null || data === void 0 ? void 0 : data.nextPlan,
    };
};

// @zapier/upsells@8.0.3 (1de7a616e)
